import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  learnerRecords: {
    id: 'learnerRecords',
    defaultMessage: 'My Learner Records',
    description: 'A message of Learner Records navigation tab',
  },
  verifiableCredentials: {
    id: 'verifiableCredentials',
    defaultMessage: 'Verifiable Credentials',
    description: 'A message of Verifiable Credentials navigation tab',
  },
});

export default messages;
